<div class="register">
  <div class="body">
    <div class="company-container flex flex-col gap-16">
      <div class="inp">
        <fun-input placeholder="Ciudad natal"
          [parentForm]="partnerForm"
          [formControlKeys]="formControlKeys"
          [errorMessages]="errorMessages"
          [isSubmit]="isSubmit"
          controlName="birthCity"
          type="text"
          [errorLogin]="errorAmount"
          labelName="Ciudad natal"
          (keyup)="getInfo()"
          (click)="getInfo()"></fun-input>
      </div>
      <div class="inp">
        <fun-input *ngIf="countriesLoaded"
          placeholder="Nacionalidad"
          [parentForm]="partnerForm"
          [formControlKeys]="formControlKeys"
          [errorMessages]="errorMessages"
          [isSubmit]="isSubmit"
          controlName="nationality"
          type="select"
          [errorLogin]="errorAmount"
          labelName="Nacionalidad"
          (selectChange)="getInfo()"
          (keyup)="getInfo()"
          (click)="getInfo()"
          [items]="countriesList"
          [selectedItem]="108"></fun-input>
        <fun-skeleton-input *ngIf="!countriesLoaded"></fun-skeleton-input>
      </div>
      <div class="inp">
        <fun-input *ngIf="countriesLoaded"
          placeholder="País de nacimiento"
          [parentForm]="partnerForm"
          [formControlKeys]="formControlKeys"
          [errorMessages]="errorMessages"
          [isSubmit]="isSubmit"
          controlName="birthCountry"
          type="select"
          [errorLogin]="errorAmount"
          labelName="País de nacimiento"
          (selectChange)="getInfo()"
          (keyup)="getInfo()"
          (click)="getInfo()"
          [items]="countriesList"
          [selectedItem]="108"></fun-input>
        <fun-skeleton-input *ngIf="!countriesLoaded"></fun-skeleton-input>
      </div>
    </div>
  </div>
</div>